"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const tags_1 = require("../../atoms/tags");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const moment_1 = __importDefault(require("moment"));
const LabelsWrapper = styled_components_1.default.div `
  margin-top: ${({ theme }) => theme.spacings.xs};
  span {
    margin-top: ${({ theme }) => theme.spacings.xs};
  }

  span:last-of-type {
    margin-right: ${({ theme }) => theme.spacings.xs};
  }
`;
const Labels = ({ member }) => {
    const [t, i18nInstance] = (0, react_i18next_1.useTranslation)();
    moment_1.default.locale(i18nInstance.language);
    // TODO: TS - Remove translation types casting
    const i18n = t("sidebar.userDetailCard.events", {
        returnObjects: true
    });
    const { daysToBirthday, daysToPlanEnd: daysToPeriodEnd, daysToSubscriptionsEnd } = member.events;
    const keys = [];
    for (const key in member.events) {
        if (typeof member.events[key] == "boolean" &&
            member.events[key] &&
            key !== "hasUpgraded")
            keys.push(key);
    }
    const displaySubscriptionEndTag = daysToSubscriptionsEnd >= 0 && daysToSubscriptionsEnd <= 14;
    const displayPeriodEndTag = daysToPeriodEnd >= 0 && daysToPeriodEnd <= 14 && !displaySubscriptionEndTag;
    return ((0, jsx_runtime_1.jsxs)(LabelsWrapper, { children: [((member.responseDeadlineHours || 0) > 0 ||
                (member.responseDeadlineHours || 0) < 0) && ((0, jsx_runtime_1.jsxs)(tags_1.Tag, { variant: (member.responseDeadlineHours || 0) < 0 ? "red" : "silver", children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ["fas", "alarm-exclamation"], size: "xs" }, void 0), (0, moment_1.default)().add(member.responseDeadlineHours, "h").toNow(true)] }, void 0)), daysToBirthday >= 0 && daysToBirthday < 8 && ((0, jsx_runtime_1.jsxs)(tags_1.Tag, { variant: "silver", children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ["fal", "birthday-cake"], size: "xs" }, void 0), daysToBirthday > 1 && `${daysToBirthday} ${i18n["birthdayFor"]}`, daysToBirthday === 1 && i18n["tomorrow"], daysToBirthday === 0 && i18n["birthday"]] }, void 0)), displayPeriodEndTag && ((0, jsx_runtime_1.jsxs)(PlanEndTag, { variant: "silver", children: [daysToPeriodEnd > 1 &&
                        `${i18n["endPlanFor"]} ${daysToPeriodEnd} ${i18n["endPlan"]}`, daysToPeriodEnd === 1 && i18n["endPlanTomorrow"], daysToPeriodEnd === 0 && i18n["planEndToday"]] }, void 0)), displaySubscriptionEndTag && ((0, jsx_runtime_1.jsxs)(PlanEndTag, { variant: "silver", children: [daysToSubscriptionsEnd > 1 &&
                        `${i18n["subscriptionEndFor"]} ${daysToSubscriptionsEnd} ${i18n["endPlan"]}`, daysToSubscriptionsEnd === 1 && i18n["subscriptionEndTomorrow"], daysToSubscriptionsEnd === 0 && i18n["subscriptionEndToday"]] }, void 0)), member.hasUpgradedToCoaching && ((0, jsx_runtime_1.jsx)(tags_1.Tag, { variant: "silver", children: i18n["hasUpgradedToCoaching"] }, void 0)), member.coachingDays &&
                member.coachingDays.map((day) => ((0, jsx_runtime_1.jsx)(tags_1.Tag, { variant: "silver", children: moment_1.default.weekdays(day + 1) }, day))), keys.map((key) => ((0, jsx_runtime_1.jsx)(tags_1.Tag, { variant: "silver", children: i18n[key] }, key)))] }, void 0));
};
exports.default = Labels;
const PlanEndTag = (0, styled_components_1.default)(tags_1.Tag) `
  white-space: normal;
  width: 100%;
`;
//# sourceMappingURL=labels.js.map